"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var a = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var a__default = /*#__PURE__*/_interopDefaultLegacy(a);

var p=a__default["default"].a`
  display: inline-flex;
  align-items: baseline;
  cursor: pointer;
  color: ${({$colorToken:r})=>`var(--${r})`};
  font-weight: var(--font-weight-bold);
  text-decoration: none;
  gap: ${({$icon:r,$inline:o})=>r&&(o?"var(--spacing-x-small)":"var(--spacing-small)")};

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    border-radius: var(--border-radius-small);
    outline-offset: 1px;
    outline-color: var(--border-link-focus);
    outline-width: var(--border-width-small);
  }

  &:active > span {
    color: ${({$activeColorToken:r})=>`var(--${r})`};
  }
`,s=a__default["default"].span``;var m=({children:r,icon:o,inline:d=!1,size:i="regular",colorToken:n="foreground-link",activeColorToken:f="foreground-link-active",...c})=>jsxRuntime.jsxs(p,{rel:o?"noopener noreferrer":void 0,target:o?"_blank":void 0,$icon:o,$inline:d,$colorToken:n,$activeColorToken:f,...c,children:[jsxRuntime.jsx(chunk2VCHSK65_js.d,{forwardedAs:"span",weight:"bold",size:i,colorToken:n,children:r}),o&&jsxRuntime.jsx(s,{children:jsxRuntime.jsx(chunkLXX3SSRV_js.b,{size:i,icon:o})})]});m.displayName="Link";var k=a__default["default"](m)``;

exports.a = k;
